import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useOLMap } from './MapContext';
export const MapView = () => {
    const olMap = useOLMap();
    const mapContainerRef = useRef(null);
    // Register/unregister OLMap to DOM
    useEffect(() => {
        if (olMap && mapContainerRef.current) {
            olMap.setTarget(mapContainerRef.current);
        }
    }, [olMap]);
    return (_jsx("div", { ref: mapContainerRef, style: { position: 'absolute', inset: 0, backgroundColor: '#fff' }, children: _jsx("style", { children: `.ol-viewport,
          .ol-unselectable {
            -webkit-user-select: none;
            -moz-user-select: none;
            user-select: none;
          }
          .ol-selectable {
            -webkit-user-select: text;
            -moz-user-select: text;
            user-select: text;
          }
          .ol-grabbing {
            cursor: grabbing;
          }
          .ol-grab {
            cursor: grab;
          }` }) }));
};
//# sourceMappingURL=MapView.js.map